import '@webcomponents/shadycss/entrypoints/custom-style-interface';

export function addDocStyle({ content, /* optional as mark */ cssPath, target }) {
  const style = document.createElement('style');
  style.textContent = content;
  style.setAttribute('path', cssPath); // for log

  let root = window.document;
  if (target) {
    root = target.getRootNode();
  }
  if (root instanceof window.ShadowRoot) {
    root.appendChild(style);
  } else {
    root.head.appendChild(style);
  }
}

const cssFiles = {};

export function addLinkFile(cssPath, target) {
  if (!cssFiles[cssPath]) {
    cssFiles[cssPath] = new Promise(resolve => {
      const link = document.createElement('link');
      link.setAttribute('rel', 'stylesheet');
      link.setAttribute('href', cssPath);

      let root = window.document;
      if (target) {
        root = target.getRootNode();
      }
      if (root instanceof window.ShadowRoot) {
        root.appendChild(link);
      } else {
        root.head.appendChild(link);
      }
      link.onload = function () {
        resolve(true);
      };
    });
  }
  return cssFiles[cssPath];
}
